import { render, staticRenderFns } from "./SpamSenders.vue?vue&type=template&id=067d5ad5&scoped=true&"
import script from "./SpamSenders.vue?vue&type=script&lang=ts&"
export * from "./SpamSenders.vue?vue&type=script&lang=ts&"
import style0 from "../../assets/css/helpdesk/spam-senders.css?vue&type=style&index=0&id=067d5ad5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067d5ad5",
  null
  
)

export default component.exports